import { Link, RichTextEditor } from "@mantine/tiptap";
import "@mantine/tiptap/styles.css";
import Highlight from "@tiptap/extension-highlight";
import SubScript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
}
export function TextEditor({ value, onChange }: RichTextEditorProps) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link,
      Superscript,
      SubScript,
      Highlight,
      TextAlign.configure({ types: ["heading", "paragraph"] })
    ],
    content: value,
    onUpdate: ({ editor: prop }) => {
      onChange(prop.getHTML());
    }
  });

  return (
    <RichTextEditor editor={editor} data-testid="editortext-container">
      <RichTextEditor.Toolbar sticky stickyOffset={60} data-testid="editortext-toolbar">
        <RichTextEditor.ControlsGroup data-testid="editortext-controls-basic">
          <RichTextEditor.Bold data-testid="editortext-bold" />
          <RichTextEditor.Italic data-testid="editortext-italic" />
          <RichTextEditor.Underline data-testid="editortext-underline" />
          <RichTextEditor.Strikethrough data-testid="editortext-strikethrough" />
          <RichTextEditor.ClearFormatting data-testid="editortext-clearformatting" />
          <RichTextEditor.Highlight data-testid="editortext-highlight" />
          <RichTextEditor.Code data-testid="editortext-code" />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup data-testid="editortext-controls-headers">
          <RichTextEditor.H1 data-testid="editortext-h1" />
          <RichTextEditor.H2 data-testid="editortext-h2" />
          <RichTextEditor.H3 data-testid="editortext-h3" />
          <RichTextEditor.H4 data-testid="editortext-h4" />
        </RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup data-testid="editortext-controls-links">
          <RichTextEditor.Link data-testid="editortext-link" />
          <RichTextEditor.Unlink data-testid="editortext-unlink" />
        </RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup data-testid="editortext-controls-blocks">
          <RichTextEditor.Blockquote data-testid="editortext-blockquote" />
          <RichTextEditor.Hr data-testid="editortext-hr" />
          <RichTextEditor.BulletList data-testid="editortext-bulletlist" />
          <RichTextEditor.OrderedList data-testid="editortext-orderedlist" />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup data-testid="editortext-controls-align">
          <RichTextEditor.AlignLeft data-testid="editortext-alignleft" />
          <RichTextEditor.AlignCenter data-testid="editortext-aligncenter" />
          <RichTextEditor.AlignJustify data-testid="editortext-alignjustify" />
          <RichTextEditor.AlignRight data-testid="editortext-alignright" />
        </RichTextEditor.ControlsGroup>
      </RichTextEditor.Toolbar>

      <RichTextEditor.Content h={"10rem"} className="editor" data-testid="editortext-content" />
    </RichTextEditor>
  );
}
